import { createPermission } from '@backstage/plugin-permission-common';

// Mirror of packages/backend/src/plugins/permissions.ts — the frontend
// can't depend on backend packages, so these are duplicated. Names must
// match for the custom permission policy to gate them.

// Gates the catalog/APIs/Docs/Create sidebar nav. Basic (not resource)
// permission so usePermission can check it without a resourceRef.
export const catalogNavAccessPermission = createPermission({
  name: 'catalogNav.access',
  attributes: { action: 'read' },
});

export const releaseAccessPermission = createPermission({
  name: 'release.access',
  attributes: { action: 'update' },
});

export const releaseNotesAccessPermission = createPermission({
  name: 'releaseNotes.access',
  attributes: { action: 'update' },
});

export const previewAccessPermission = createPermission({
  name: 'preview.access',
  attributes: { action: 'update' },
});

export const aiQaAccessPermission = createPermission({
  name: 'aiqa.access',
  attributes: { action: 'update' },
});
